import React, { useCallback, useState } from 'react';
import classes from './style.module.scss';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import AccessControl from '~/accessControl';
import Button from '~/app/common/Button';
import { useStoreActions, useStoreState } from '~/store';
import { IssueStatuses } from '~/app/data/statuses/issue';
import useTranslation from '~/app/hooks/useTranslation';
import { IssueDetails } from '~/types';
import CompleteIssue from '~/issues/CompleteIssue';

export type CompleteIssueDialogComponent = React.FC;

const CompleteIssueDialog = () => {
    const { t } = useTranslation('issue.issueClose');
    const [isOpenCloseIssueForm, setIsOpenCloseIssueForm] = useState<boolean>(false);
    const issueDetails = useStoreState(state => state.issue.data);
    const IssueFetchAction = useStoreActions(actions => actions.issue.fetchIssue);
    const IssueFetchOfflineAction = useStoreActions(actions => actions.issue.fetchOfflineIssue);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const setShowCompleted = useStoreActions(actions => actions.issue.setShowCompleted);

    const hasSimplifiedWorkorderEnabled = useStoreState(state => state.issue.data?.hasSimplifiedWorkorderEnabled ?? false);
    const issueDepartment = useStoreState(state => state.issue.data.issueDepartmentId);
    const user = useStoreState(state => state.user.data);
    
    const closeIssueClickHandler = useCallback((state: boolean) => (): void => {
        setIsOpenCloseIssueForm(state);
    }, []);

    const fetchIssueDetails = useCallback(async (id: IssueDetails['id']) => {
        await (netWorkStatus ? IssueFetchOfflineAction : IssueFetchAction)(id);
        setShowCompleted(true);
    }, [IssueFetchAction, IssueFetchOfflineAction, netWorkStatus, setShowCompleted]);

    if (netWorkStatus || 
        !(user.is_active && (user?.departments ?? []).includes(Number(issueDepartment ?? '-1')) && !!issueDetails.workOrderNo && !!hasSimplifiedWorkorderEnabled) ||
        (issueDetails?.status !== IssueStatuses.INPROGRESS && !issueDetails.workOrderNo)
    ) {
        return (<></>);
    }

    return (
        <>
            <AccessControl requiredPermissions={PERMISSION_GROUPS.closeIssues} >
                <div className={`${classes['button']}`}>
                    <Button className={`${classes['completeIssue']}`} onClick={closeIssueClickHandler(true)}> { t('closeIssue') } </Button>
                </div>

                <CompleteIssue open={isOpenCloseIssueForm} onClose={closeIssueClickHandler(false)} issueDetails={issueDetails} onSave={fetchIssueDetails} />
            </AccessControl>
        </>
    );
};


export default CompleteIssueDialog;